import jwtAuthAxios from "../../services/auth/jwtAuth";

const whatsappServices = {};

// GET /api/v1/whatsapp/conversations
// params: { page, status, mode, sales_flow, search, archived }
whatsappServices.getConversations = async (params = {}) => {
    const query = new URLSearchParams();
    if (params.page)        query.append("page", params.page);
    if (params.status)      query.append("status", params.status);
    if (params.mode)        query.append("mode", params.mode);
    if (params.sales_flow)  query.append("sales_flow", params.sales_flow);
    if (params.search)      query.append("search", params.search);
    if (params.archived)    query.append("archived", params.archived);

    const { data } = await jwtAuthAxios.get(`/whatsapp/conversations?${query.toString()}`);
    return data;
};

// GET /api/v1/whatsapp/conversations/usage_report
// Uso del WhatsApp por usuarios registrados, por empresa/usuario, últimos 6 meses.
whatsappServices.getUsageReport = async () => {
    const { data } = await jwtAuthAxios.get(`/whatsapp/conversations/usage_report`);
    return data;
};

// GET /api/v1/whatsapp/conversations/:id
whatsappServices.getConversation = async (id) => {
    const { data } = await jwtAuthAxios.get(`/whatsapp/conversations/${id}`);
    return data.data || data;
};

// POST /api/v1/whatsapp/conversations/:id/send_message
whatsappServices.sendMessage = async (id, message) => {
    const { data } = await jwtAuthAxios.post(`/whatsapp/conversations/${id}/send_message`, { message });
    return data;
};

// GET /api/v1/whatsapp/conversations/templates
// Plantillas aprobadas por Meta con que se le escribe a quien no nos escribió en 24 horas.
whatsappServices.getTemplates = async () => {
    const { data } = await jwtAuthAxios.get(`/whatsapp/conversations/templates`);
    return data.data || [];
};

// POST /api/v1/whatsapp/conversations — escribirle a un número nuevo con una plantilla.
// body: { phone, name, template, params: [] }. Devuelve la conversación con sus mensajes.
whatsappServices.createConversation = async (body) => {
    const { data } = await jwtAuthAxios.post(`/whatsapp/conversations`, body);
    return data.data || data;
};

// POST /api/v1/whatsapp/conversations/:id/send_template — retomar con la ventana cerrada.
whatsappServices.sendTemplate = async (id, body) => {
    const { data } = await jwtAuthAxios.post(`/whatsapp/conversations/${id}/send_template`, body);
    return data.data || data;
};

// PATCH /api/v1/whatsapp/conversations/:id/archive | unarchive — archiva al contacto.
whatsappServices.setArchived = async (id, archived) => {
    const { data } = await jwtAuthAxios.patch(`/whatsapp/conversations/${id}/${archived ? "archive" : "unarchive"}`);
    return data;
};

// PATCH /api/v1/whatsapp/conversations/:id/close — cierra la conversación: pasa el prospecto a
// HubSpot si no estaba, la devuelve al bot y archiva al contacto hasta que vuelva a escribir.
// Devuelve { hubspot: { status: "sincronizado" | "ya_estaba" | "registrado" | "sin_hubspot" } }.
whatsappServices.closeConversation = async (id) => {
    const { data } = await jwtAuthAxios.patch(`/whatsapp/conversations/${id}/close`);
    return data;
};

// PATCH /api/v1/whatsapp/conversations/:id/update_mode
// body: { mode: "bot"|"human", status: "open"|"closed" }
whatsappServices.updateMode = async (id, attrs) => {
    const { data } = await jwtAuthAxios.patch(`/whatsapp/conversations/${id}/update_mode`, attrs);
    return data;
};

// POST /api/v1/push_subscriptions — subscribe current device
const VAPID_PUBLIC_KEY = "BI696bd_nWh4vS8WFEVvK-_TFnCSRUNP4kB0-9beBcP72FmvHkDJOKOE8x-g-EXzkmekDI2SMHZKE8MwkVS8XvU=";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

whatsappServices.subscribePush = async () => {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
        throw new Error("Este navegador no soporta notificaciones");
    }

    // Se registra aquí también (idempotente) por si el registro de index.js todavía no
    // terminó; `ready` se quedaría esperando para siempre si nunca hubo registro.
    await navigator.serviceWorker.register("/service-worker.js");
    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        });
    }

    const sub = subscription.toJSON();
    await jwtAuthAxios.post("/push_subscriptions", {
        endpoint:    sub.endpoint,
        p256dh_key:  sub.keys.p256dh,
        auth_key:    sub.keys.auth,
    });

    return subscription;
};

// POST /api/v1/push_subscriptions/test — aviso de prueba a los dispositivos del usuario
whatsappServices.testPush = async () => {
    const { data } = await jwtAuthAxios.post("/push_subscriptions/test");
    return data;
};

export default whatsappServices;
